// Code generated by "typescripter -type=DatasetOrderStatus -linecomment -output=../../portal/src/enums/datasetorderstatusenum.ts"; DO NOT EDIT.

export enum DatasetOrderStatusEnum {
  DatasetOrderStatusOrdered = 'ordered',
  DatasetOrderStatusQuotesSigned = 'quotes_signed',
  DatasetOrderStatusPaid = 'paid',
  DatasetOrderStatusPartialRefund = 'partial_refund',
  DatasetOrderStatusFullRefund = 'full_refund',
}
